module.exports = __webpack_public_path__ + "img/handling-massive-product-db-in-magento.fb9ffb3f.jpeg";